import m from "classnames";
import { container as c, isEditMode as n, list as a } from "./SocialLinks.css.js";
import { jsx as i } from "react/jsx-runtime";
function p({
  element: t,
  className: s,
  isEditMode: o,
  children: e
}) {
  const {
    customAttributes: r
  } = t;
  return /* @__PURE__ */ i("div", {
    ...r,
    className: m(s, c, {
      [n]: o
    }),
    children: /* @__PURE__ */ i("div", {
      className: a,
      children: e
    })
  });
}
export {
  p as SocialLinksElement
};
